"use client";
import { useState, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import superjson from "superjson";
import { env } from "@env/unsafe-public";
import { makeQueryClient } from "./query-client";
import type { QueryClient } from "@tanstack/react-query";
import type { AppRouter } from "@src/trpc-router";

export const trpc = createTRPCReact<AppRouter>();

let clientQueryClientSingleton: QueryClient;

const getQueryClient = () => {
  if (typeof window === "undefined") {
    return makeQueryClient();
  }
  return (clientQueryClientSingleton ??= makeQueryClient());
};

const getUrl = () => {
  const base = typeof window !== "undefined" ? "" : env.BASE_URL;
  return `${base}/api/trpc`;
};

export const TRPCProvider = (props: { children: ReactNode }) => {
  const queryClient = getQueryClient();
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: getUrl(),
          transformer: superjson,
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {props.children}
      </QueryClientProvider>
    </trpc.Provider>
  );
};
